import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';

import { DriverDashboardRoutingModule } from './driver-dashboard-routing.module';
import { DriverDashboardComponent } from './driver-dashboard/driver-dashboard.component';
import { BerbixModule } from 'berbix-angular';
import { DriverIdCardComponent } from './driver-id-card/driver-id-card.component';
import { ActionsModule } from '../shared/actions/actions.module';

@NgModule({
  declarations: [DriverDashboardComponent, DriverIdCardComponent],
  imports: [
    CommonModule, 
    DriverDashboardRoutingModule, 
    /* BerbixModule, */ 
    ActionsModule,
    MatButtonModule,
    MatIconModule,
    MatBottomSheetModule
  ]
})
export class DriverDashboardModule {}

export { DriverIdCardComponent } from './driver-id-card/driver-id-card.component';

